'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OpenAPI = require('./OpenAPI');

var _OpenAPI2 = _interopRequireDefault(_OpenAPI);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _OpenAPI2.default;
exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/components/OpenAPI/index.jsx');
}();

;